<template>
  <div class="success">
    <h1>恭喜</h1>
    <p>签名提交成功...^_^</p>
    <div class="btn">
      <a-button type="primary" danger @click="backToHome">返回首页</a-button>
      <a-button v-if="image_customer === ''" type="primary" @click="backToSign('customer')">用户签名</a-button>
      <a-button v-if="image_staff === ''" type="primary" @click="backToSign('staff')">司机签名</a-button>
    </div>
  </div>
</template>

<script setup>
import axios from 'axios'
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const uuid = ref(null)
const image_staff = ref(null)
const image_customer = ref(null)

const fetchData = () => {
  return axios.get(`https://api.gdpinganxing.com/api/cs?uuid=${uuid.value}`)
}
const backToHome = () => {
  router.push(`/${uuid.value}`)
}
const backToSign = (type) => {
  router.push(`/sign/${type}/${uuid.value}`)
}

onMounted(async() => {
  uuid.value = route.params.id
  const response = await fetchData()
  if (response.data.code != 200) {
    alert('获取案件信息失败...请联系客服...')
    return
  }
  console.log(response.data.data.signature.detail)
  image_staff.value = response.data.data.signature.detail.image_staff
  image_customer.value = response.data.data.signature.detail.image_customer
})
</script>

<style>
.success {
  margin-top: 64px;
  text-align: center;
}
.success > h1 {
  color: #999999;
}
.success > p {
  margin-top: 48px;
  margin-bottom: 48px;
  color: #333333;
}
.success > .btn {
  display: flex;
  justify-content: center;
  margin-top: 48px;
}
.success > .btn > button {
  margin-right: 6px;
  margin-left: 6px;
}
</style>